import { render, staticRenderFns } from "./ant-t.vue?vue&type=template&id=0b99734c&scoped=true"
import script from "./ant-t.vue?vue&type=script&lang=js"
export * from "./ant-t.vue?vue&type=script&lang=js"
import style0 from "./ant-t.vue?vue&type=style&index=0&id=0b99734c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b99734c",
  null
  
)

export default component.exports